import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortedAscendingArrows = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .9,
		d: "M1.5 7L0.5 6L4 2.5L7.5 6L6.5 7L4.75 5.25V14H3.25V5.25L1.5 7Z",
		fill: "#17181E"
	}), /* @__PURE__ */ _jsx("path", {
		opacity: .4,
		d: "M12 10.75V2H10.5V10.75L8.75 9L7.75 10L11.25 13.5L14.75 10L13.75 9L12 10.75Z",
		fill: "#17181E"
	})]
});
export default SvgSortedAscendingArrows;
